import React from 'react';
import { RetinaPicture } from 'client/components/RetinaPicture';
import {
  Container,
  LeftColumn,
  RightColumn,
  Section,
  TextContainer,
  CampaignBudget,
} from './styles';

export function BrandPartners() {
  return (
    <Section>
      <h2>Partner with top brands</h2>
      <Container
        className="BrandPartners-imageSection"
        flexDirectionMd="column-reverse"
      >
        <LeftColumn>
          <RetinaPicture
            imagePath="/span/span-headphones-lady"
            alt="Woman listening to a podcast while looking at her phone"
            fallbackExtension="jpg"
          />
        </LeftColumn>
        <RightColumn>
          <TextContainer>
            <h3 className="BrandPartners-imageSectionHeading">
              Spotify Audience Network
            </h3>
            <p>
              Spotify Audience Network (SPAN), which powers Automated ads, is
              Spotify’s proprietary audio advertising marketplace in which
              advertisers of all sizes will be able to connect with listeners
              consuming a broad range of content. These include Spotify’s
              Originals & Exclusives, podcasts via Megaphone and Anchor, and
              ad-supported music.
            </p>
            <p>
              By using Automated ads, you’ll be part of a marketplace with some
              of the top brands in the world, who want to tap into your unique
              audience with relevant ads.
            </p>
          </TextContainer>
        </RightColumn>
      </Container>
      <Container className="BrandPartners-budgetSection">
        <LeftColumn>
          <TextContainer>
            <h3>
              Are you a business interested in advertising with Anchor and
              Spotify?
            </h3>
            <p>
              We’re always looking for new partners, and we have a variety of
              solutions for all budgets and campaign goals. Here’s how to get in
              touch, based on your campaign budget:
            </p>
          </TextContainer>
        </LeftColumn>
        <RightColumn>
          <TextContainer>
            <CampaignBudget>
              <p>Under $10,000</p>
              <a
                href="https://anch.co/adstudio"
                target="_blank"
                rel="noreferrer noopener"
              >
                Spotify Ad Studio
              </a>
            </CampaignBudget>
            <CampaignBudget>
              <p>Between $10,000 and $50,000</p>
              <a
                href="https://spotify.co1.qualtrics.com/jfe/form/SV_4UsiZwa0cpDLaS2"
                target="_blank"
                rel="noreferrer noopener"
              >
                Get started
              </a>
            </CampaignBudget>
            <CampaignBudget>
              <p>Above $50,000</p>
              <a
                href="https://anch.co/spotifyaudiencenetwork"
                target="_blank"
                rel="noreferrer noopener"
              >
                Get in touch
              </a>
            </CampaignBudget>
          </TextContainer>
        </RightColumn>
      </Container>
    </Section>
  );
}
